// eslint-disable-next-line import/no-unresolved
import { set } from '@/utils/vuex';

const odataEndpoints = require('./odataEndpoints.json');

const mutations = {};
odataEndpoints.forEach((odata) => {
  mutations[odata.endPoint] = set(odata.endPoint);
  mutations[odata.name] = set(odata.name);
});
export default mutations;
